import config from '@plone/volto/registry';
import { defineMessages } from 'react-intl';
import { insertInArray } from '@plone/volto/helpers/Utils/Utils';
import { addStyling } from '@plone/volto/helpers/Extensions/withBlockSchemaEnhancer';

const messages = defineMessages({
  Description: {
    id: 'Description',
    defaultMessage: 'Description',
  },
  Title: {
    id: 'Title',
    defaultMessage: 'Title',
  },
  BlockWidth: {
    id: 'Block Width',
    defaultMessage: 'Block Width',
  },
  Align: {
    id: 'Alignment',
    defaultMessage: 'Alignment',
  },
  size: {
    id: 'Image size',
    defaultMessage: 'Image size',
  },
});

export const fieldImageBlockSchema = (props) => {
  const { formData, intl } = props;
  return {
    title: 'Field Image Block',
    description: 'Display a group of persons involved in a project.',
    fieldsets: [
      {
        id: 'default',
        title: 'Default',
        fields: ['image', 'align', 'size'],
      },
    ],
    properties: {
      image: {
        title: 'image',
        description: 'Enter the property name (eg portrait, lc_image)',
        default: 'image',
        widget: 'text',
      },
      // image_text: {
      //   title: 'image_text',
      //   description: 'Enter a text',
      //   widget: 'text',
      // },
      align: {
        title: intl.formatMessage(messages.Align),
        default: 'center',
        widget: 'align',
      },
      size: {
        title: intl.formatMessage(messages.size),
        default: 'l',
        widget: 'image_size',
      },
    },
    required: ['image'],
  };
};

export const standAloneFieldImageBlockSchemaEnhancer = ({
  formData,
  schema,
  intl,
}) => {
  // if (formData.image) {
  schema.properties.align.default = 'center';
  schema.properties.align.actions = ['left', 'right', 'center'];

  schema.properties.size.default = 'l';
  schema.properties.size.disabled = formData.align === 'center';
  schema.properties.styles.schema.fieldsets[0].fields = [
    'blockWidth:noprefix',
    ...schema.properties.styles.schema.fieldsets[0].fields,
  ];

  schema.properties.styles.schema.properties['blockWidth:noprefix'] = {
    widget: 'blockWidth',
    title: intl.formatMessage(messages.BlockWidth),
    default: 'default',
    filterActions: ['narrow', 'default', 'layout', 'full'],
    actions: config.blocks.widths,
  };

  schema.properties.styles.schema.properties['blockWidth:noprefix'].disabled =
    formData.align === 'left' || formData.align === 'right';
  // }

  return schema;
};

export default fieldImageBlockSchema;
